import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import UsersContent from "../../components/Pages/Users";
import { useTranslation } from "react-i18next";
import VaadimListContent from "../../components/Pages/Vaadim";

const { displayName } = config;

export default function VaadimList(): React.ReactNode | null {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Vaadim list`;
  }, []);

  return (
    <Layout title="Vaadim list">
      <VaadimListContent />
    </Layout>
  );
}
